import React from 'react';
import Icon from 'components/styleguide/icon/Icon';

const styles = require('./FlagsList.module.scss');

const FLAG_LABELS: Record<string, string> = {
  career_gaps: 'Career gaps',
  critical_skill_gap: 'Critical skill gap',
  job_hopping: 'Job hopping',
  overqualified: 'Overqualified',
  underqualified: 'Underqualified',
};

export interface Props {
  flags: { detail: string; type: string }[];
}

// AI-detected patterns as warning notices. Non-blocking — the curator
// decides whether to act.
export default function FlagsList({ flags }: Props) {
  if (flags.length === 0) {
    return <p className={styles['ui-flags__empty']}>No flags detected.</p>;
  }

  return (
    <ul aria-label="Flags" className={styles['ui-flags']}>
      {flags.map((flag) => (
        <li className={styles['ui-flags__item']} key={flag.type}>
          <Icon aria-hidden className={styles['ui-flags__icon']} name="circleAlert" size="sm" />
          <div>
            <span className={styles['ui-flags__title']}>{FLAG_LABELS[flag.type] || flag.type}</span>
            <p className={styles['ui-flags__detail']}>{flag.detail}</p>
          </div>
        </li>
      ))}
    </ul>
  );
}
